import { useState, useEffect } from "react";
import { Heart, Shuffle } from "lucide-react";
import { COMPLIMENTS } from "@/lib/vibesContent";

export default function ComplimentCard() {
  const [, tick] = useState(0);
  const [offset, setOffset] = useState(0);
  useEffect(() => { const iv = setInterval(() => tick((t) => t + 1), 60000); return () => clearInterval(iv); }, []);
  const slot = Math.floor(Date.now() / 1800000);
  const compliment = COMPLIMENTS[(slot + offset) % COMPLIMENTS.length];
  const minsLeft = 30 - (Math.floor(Date.now() / 60000) % 30);
  return (
    <div className="space-y-2 py-1 text-center">
      <Heart className="mx-auto h-6 w-6 text-pink-500 animate-pulse" />
      <p data-testid="compliment-text" className="font-display text-base font-semibold leading-snug">
        {compliment}
      </p>
      <div className="flex items-center justify-between text-[10px] font-mono uppercase tracking-wider opacity-50">
        <span data-testid="compliment-countdown">next in {minsLeft}m</span>
        <button data-testid="compliment-shuffle" onClick={() => setOffset((o) => o + 1)}
          className="flex items-center gap-1 rounded-full px-2 py-0.5 transition-colors hover:bg-black/10">
          <Shuffle className="h-3 w-3" /> another
        </button>
      </div>
    </div>
  );
}
